import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Translation from '../../../../translation/translation';
import { Filters } from '../../../../../constants/filter/filters';
import LastUsedConfiguratorStore from '../../../../../stores/last_used_configurator_store';
import RegoLookupStore from '../../../../../stores/rego_lookup_store';
import VehicleFilterStore from '../../../../../stores/vehicle_configurator_store';
import { types } from '../../../../../../_constants/product/types';
import LightboxActiveFilter from './lightBoxActiveFilter';
import LightboxActiveBooleanFilter from './lightboxActiveBooleanFilter';
import { getDefaultValueForFilter } from '../../../../../helper/filters/get_default_value_for_filter';
import { getTypeByFilter } from '../../../../../helper/filters/get_type_by_filter';
import { FilterTypes } from '../../../../../constants/filter/filter_types';
import getTranslatedText from '../../../../../helper/get_translated_text';
class LightboxVehicleActiveFilters extends Component {
    constructor() {
        super();
        this.state = {
            lastUsedConfiguratorStore: LastUsedConfiguratorStore.getState(),
            regoLookupStore: RegoLookupStore.getState(),
            vehicleConfiguratorStore: VehicleFilterStore.getState(),
        };
    }

    componentDidMount() {
        LastUsedConfiguratorStore.addListener(() => this._getLastUsedConfiguratorStore());
        RegoLookupStore.addListener(() => this._getRegoLookupStore());
        VehicleFilterStore.addListener(() => this._getVehicleConfiguratorStore());
    }

    componentWillUnmount() {
        LastUsedConfiguratorStore.addListener(() => this._getLastUsedConfiguratorStore());
        RegoLookupStore.addListener(() => this._getRegoLookupStore());
        VehicleFilterStore.addListener(() => this._getVehicleConfiguratorStore());
    }

    _getLastUsedConfiguratorStore() {
        this.setState({
            lastUsedConfiguratorStore: LastUsedConfiguratorStore.getState(),
        });
    }

    _getRegoLookupStore() {
        this.setState({
            regoLookupStore: RegoLookupStore.getState(),
        });
    }

    _getVehicleConfiguratorStore() {
        this.setState({
            vehicleConfiguratorStore: VehicleFilterStore.getState(),
        });
    }
    render() {
        const props = this.props;
        const { lastUsedConfiguratorStore, regoLookupStore, vehicleConfiguratorStore } = this.state;
        const lastUsedConfigurator = lastUsedConfiguratorStore.configuratorSource;

        let tyreSizeValue = props.filterValues[Filters.WIDTH] + 'R' + props.filterValues[Filters.DIAMETER] + ' ' + props.filterValues[Filters.LOAD_INDEX];
        if (props.filterValues[Filters.HEIGHT].length > 0) {
            tyreSizeValue = props.filterValues[Filters.WIDTH] + '/' + props.filterValues[Filters.HEIGHT] + 'R' + props.filterValues[Filters.DIAMETER] + ' ' + props.filterValues[Filters.LOAD_INDEX];
        }

        let filterValues = [];
        if ('vehicle_configurator' === lastUsedConfigurator) {
            filterValues = vehicleConfiguratorStore.values;
            for (let i = 0; i < vehicleConfiguratorStore.tyreOptions.length; i++) {
                if (vehicleConfiguratorStore.tyreOptions[i][1].includes(tyreSizeValue.trim())) {
                    filterValues[Filters.VEHICLE_TYRES] = vehicleConfiguratorStore.tyreOptions[i][0];
                    break;
                }
            }
        } else {
            filterValues = regoLookupStore.values;
        }

        let selectedTyrePart = filterValues[Filters.VEHICLE_TYRES].split('|');
        let profilePart = (0 == selectedTyrePart[1] || '' == selectedTyrePart[1]) ? '' : '/' + selectedTyrePart[1];
        let tyreSize = filterValues[Filters.VEHICLE_TYRES] ? selectedTyrePart[0]
            + profilePart
            + 'R' + selectedTyrePart[2] + ' ' : '';
        let standardTyre = (selectedTyrePart[3] === 'is_non_standard') ? '' : '(Standard) ';

        let loadIndex = '';
        if (typeof selectedTyrePart[4] !== 'undefined'
            && selectedTyrePart[4].length > 0 && selectedTyrePart[4] !== 'undefined') {
            loadIndex = selectedTyrePart[4];
        }

        let speedIndex = '';
        if (typeof selectedTyrePart[5] !== 'undefined'
            && selectedTyrePart[5].length > 0 && selectedTyrePart[5] !== 'undefined') {
            speedIndex = selectedTyrePart[5];
        }

        const selectedTyre = filterValues[Filters.VEHICLE_TYRES] ? tyreSize + standardTyre + loadIndex + speedIndex : '';
        const allowedFilters = [
            Filters.MANUFACTURER,
            Filters.MODEL,
            Filters.PRICE_MIN,
            Filters.PRICE_MAX,
            Filters.RUN_FLAT,
            Filters.VEHICLE_TYPE,
            Filters.USAGE,
            Filters.SEASON,
            Filters.EV,
            Filters.TECHNOLOGY,
            Filters.LABEL_NOISE,
            Filters.LABEL_WET_GRIP,
            Filters.LABEL_FUEL_EFFICIENCY,
            Filters.UTQG_TREADWEAR_GROUP,
            Filters.UTQG_TRACTION,
            Filters.UTQG_TEMPERATURE,
        ];
        const filterActiveFiltersByProductType = productType => (filter) => {
            const { key, value } = filter;
            if (productType === types.WHEEL) {
                return getDefaultValueForFilter(key) !== value && key !== 'postcode';
            }
            return getDefaultValueForFilter(key) !== value && value && value !== '' &&
                allowedFilters.includes(key);
        };
        const filterSorting = [
            Filters.LOAD_INDEX,
            Filters.SPEED_INDEX,
            Filters.MANUFACTURER,
            Filters.MODEL,
            Filters.PRICE_MIN,
            Filters.PRICE_MAX,
            Filters.FREE_FITTING,
            Filters.BUY_4_PAY_3,
            Filters.CLEARANCE,
            Filters.INSTANT_CASH,
            Filters.DISCOUNT_INSTANT_CASH_50,
            Filters.DISCOUNT_INSTANT_CASH_80,
            Filters.DISCOUNT_INSTANT_CASH_100,
            Filters.DISCOUNT_INSTANT_CASH_120,
            Filters.DISCOUNT_INSTANT_CASH_150,
            Filters.DISCOUNT_INSTANT_CASH_160,
            Filters.DISCOUNT_INSTANT_CASH_200,
            Filters.DISCOUNT_INSTANT_CASH_250,
            Filters.DISCOUNT_INSTANT_CASH_300,
            Filters.DISCOUNT_5_OFF,
            Filters.DISCOUNT_10_OFF,
            Filters.DISCOUNT_15_OFF,
            Filters.DISCOUNT_20_OFF,
            Filters.DISCOUNT_25_OFF,
            Filters.PROMO_GIFT_CARD_50,
            Filters.PROMO_GIFT_CARD_80,
            Filters.PROMO_GIFT_CARD_100,
            Filters.PROMO_GIFT_CARD_130,
            Filters.PROMO_GIFT_CARD_150,
            Filters.PROMO_GIFT_CARD_200,
            Filters.PROMO_GIFT_CARD_250,
            Filters.RUN_FLAT,
            Filters.VEHICLE_TYPE,
            Filters.QUALITY_SEGMENT_PREMIUM,
            Filters.QUALITY_SEGMENT_VALUE,
            Filters.QUALITY_SEGMENT_BUDGET,
        ];
        const sortFilters = (prev, next) => {
            const prevIndex = filterSorting.indexOf(prev.value);
            const nextIndex = filterSorting.indexOf(next.value);
            return prevIndex < nextIndex ?
                -1 : prevIndex > nextIndex ?
                    1 :
                    0
                ;
        }
        const filterActiveFilters = filterActiveFiltersByProductType;
        const activeFilters = Object.keys(props.filterValues).
            reduce((newContainer, key) => newContainer.push({ value: props.filterValues[key], key }) && newContainer,
                [])
            .filter(filterActiveFilters(props.productType))
            .sort(sortFilters);
        return (
            <div className="lightbox-overview-active-filters lightbox-overview-section">
                {filterValues[Filters.VEHICLE_MODEL] && filterValues[Filters.VEHICLE_ENGINE] && <>
                    <Translation
                        translationKey="catalog-filter-lightbox-selected-vehicle-headline"
                        className="lightbox-overview-active-filters__headline"
                        tagName="h3"
                    />
                    <p
                        className="vehicle-overview-active-filters lightbox-overview-active-filters__without-remove-filter">
                        {(filterValues[Filters.VEHICLE_MODEL] )}
                        {filterValues[Filters.VEHICLE_ENGINE] ? (filterValues[Filters.VEHICLE_ENGINE],<br />) : ''}
                        {(filterValues[Filters.VEHICLE_CHASSIS] )}
                        {
                            (Filters.VEHICLE_YEAR in filterValues) ?
                                filterValues[Filters.VEHICLE_YEAR] : filterValues[Filters.VEHICLE_YEAR_RANGE_TO]
                        }
                    </p>

                    <p className="vehicle-overview-active-filters lightbox-overview-active-filters__without-remove-filter">
                        {selectedTyre}
                    </p>
                </>}
                <Translation
                    translationKey="catalog-filter-lightbox-active-filters-headline"
                    className="lightbox-overview-active-filters__headline"
                    tagName="p"
                />

                {!activeFilters.length && <p
                    className="vehicle-overview-active-filters lightbox-overview-active-filters__without-remove-filter"
                >{getTranslatedText('catalog-filter-lightbox-no-active-filters-headline')}</p>
                }
                {
                    activeFilters
                        .map(filter => {
                            if (getTypeByFilter(filter.key) === FilterTypes.BOOLEAN_FILTER) {
                                return (
                                    <LightboxActiveBooleanFilter
                                        filterName={filter.key}
                                        onUnsetFilter={props.onUnsetFilter}
                                        key={filter.key + filter.value}
                                    />
                                );
                            }
                            const filterOption = props.filterOptions[filter.key]
                                && props.filterOptions[filter.key]
                                    .find(option => option[0].toString() === filter.value.toString());

                            if (filterOption) {
                                return (
                                    <LightboxActiveFilter
                                        filterName={filter.key}
                                        filterValue={filterOption[1].toString()}
                                        onUnsetFilter={props.onUnsetFilter}
                                        key={filter.key + filter.value}
                                    />
                                );
                            }

                            return undefined;
                        })
                }

            </div>
        );
    }
}

LightboxVehicleActiveFilters.propTypes = {
    filterValues: PropTypes.object.isRequired,
};

export { LightboxVehicleActiveFilters };
